import { generateRepositoryMethods, } from '../webapp/repository.types.js';
export const patientRepositoryMethods = generateRepositoryMethods({
    getCumulusData: {
        callMethod: 'GET',
        endpoint: '/patient/cumulus-data',
    },
    getCumulusPoints: {
        callMethod: 'GET',
        endpoint: '/patient/cumulus-points',
    },
    deletePatient: {
        callMethod: 'DELETE',
        endpoint: '/patient/delete',
    },
    updateCumulusId: {
        callMethod: 'PUT',
        endpoint: '/patient/update/cumulusId',
    },
    setShowInPatientReport: {
        callMethod: 'PUT',
        endpoint: '/patient/set-show-in-patient-report',
    },
    changeAccountName: {
        callMethod: 'POST',
        endpoint: '/user/account/change-name',
    },
    searchPatients: {
        callMethod: 'GET',
        endpoint: '/patients/search',
    },
    sendPatientReport: {
        callMethod: 'POST',
        endpoint: '/reports/patient/send',
    },
    sendTestPatientReport: {
        callMethod: 'POST',
        endpoint: '/reports/patient/send-test',
    },
    triggerAssistedRegistration: {
        callMethod: 'POST',
        endpoint: '/patient/assisted-registration/trigger',
    },
    getPatientByCustomerId: {
        callMethod: 'GET',
        endpoint: '/patient/data/by-id',
    },
    validateUsername: {
        callMethod: 'POST',
        endpoint: '/patient/validate-username',
    },
    lostPassword: {
        callMethod: 'POST',
        endpoint: '/patient/password/lost',
    },
});
//# sourceMappingURL=patient.methods.js.map